import CustomButton from "@/components/common/Button";
import { notify } from "@/components/common/Notification";
import { DynamicModuleService } from "@/services/APIs";
import { ProColumns } from "@ant-design/pro-components";
import { Popconfirm } from "antd";
import { Edit2, Plus, Trash } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfigDynamicTable from "../../../../components/BaseTable/ConfigDynamicTable";
import HRMSNavigationRoutes from "../../utils/navigationRoutes";

const EmployeeListPage = () => {
  const navigate = useNavigate();
  const schemaName = "Hrms Overview";
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleDelete = async (id: string) => {
    try {
      await DynamicModuleService.deleteItem(schemaName || "", id);
    } catch (error) {
      console.error("Delete error:", error);
      notify.error("Failed to delete employee");
    }
  };

  const handleEdit = (id: string) => {
    navigate("/hrms" + HRMSNavigationRoutes.EDIT_JOB(id));
  };

  const columns: ProColumns<any>[] = [
    {
      title: "ID",
      dataIndex: "id",
      hidden: true,
    },

    {
      title: "First Name",
      dataIndex: "firstname",
    },
    {
      title: "Last Name",
      dataIndex: "lastname",
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },

    {
      title: "Actions",
      width: 100,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="edit"
          icon={<Edit2 size={16} />}
          onClick={() => handleEdit(record.id)}
          type="text"
        />,
        <Popconfirm
          title="Are you sure you want to delete this employee?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          key="delete"
          cancelText="No"
        >
          <CustomButton
            danger
            key="delete"
            icon={<Trash size={16} />}
            type="text"
          />
        </Popconfirm>,
      ],
    },
  ];

  const toolBarRender = () => [
    <CustomButton
      key="add"
      type="primary"
      icon={<Plus size={16} />}
      onClick={() => navigate("/hrms" + HRMSNavigationRoutes.ADD_EMP)}
    >
      Add Employee
    </CustomButton>,
  ];

  return (
    <ConfigDynamicTable<any>
      columns={columns}
      selectedRowKeys={selectedRowKeys}
      setSelectedRowKeys={setSelectedRowKeys}
      rowKey="id"
      toolBarRender={toolBarRender}
      headerTitle="Employee"
      tableName={schemaName || ""}
      filter={{}}
    />
  );
};

export default EmployeeListPage;
